import React from "react"

import { Input, InputProps } from "antd"

const Password = (props: InputProps): JSX.Element => (
  <Input.Password {...props} />
)

export default Password
